import React from "react";
import Icon from "../icons/Icon";
import classes from "./MessagesNotification.module.css";

const MessagesNotification = ({ name, size = "26px", color }) => {
    
    return (
        <div className={classes.Wrapper} data-messages-notification>
            <Icon name={name} size={size} color={color} />
            <span className={classes.Dot} />
        </div>
    );
};

export default MessagesNotification;
